// SPDX-License-Identifier: AGPL-3.0-or-later

import Channels from '@app/features/channel/state/Channels';
import * as MessageCommands from '@app/features/messaging/commands/MessageCommands';
import * as NavigationCommands from '@app/features/navigation/commands/NavigationCommands';
import {FAVORITES_GUILD_ID, ME} from '@app/vendor/constants/AppConstants';
import type {JumpType} from '@app/vendor/constants/JumpConstants';

interface MessageJumpOptions {
	flash?: boolean;
	offset?: number;
	returnTargetId?: string;
	jumpType?: JumpType;
	viewContext?: 'favorites';
}
export function goToMessage(channelId: string, messageId: string, options?: MessageJumpOptions): void {
	const channel = Channels.getChannel(channelId);
	let guildId: string | null | undefined;
	if (options?.viewContext === 'favorites') {
		guildId = FAVORITES_GUILD_ID;
	} else {
		guildId = channel?.guildId;
		if (!guildId || guildId === ME) {
			guildId = ME;
		}
	}
	NavigationCommands.navigateToMessage(guildId, channelId, messageId);
	MessageCommands.jumpToMessage(
		channelId,
		messageId,
		options?.flash ?? true,
		options?.offset,
		options?.returnTargetId,
		options?.jumpType,
	);
}
export function parseMessagePath(path: string): {
	channelId: string;
	messageId: string;
} | null {
	const parts = path.split('/').filter(Boolean);
	if (parts.length < 4) return null;
	if (parts[0] !== 'channels') return null;
	const channelId = parts[2];
	const messageId = parts[3];
	if (!channelId || !messageId) return null;
	return {channelId, messageId};
}
